import { get } from "lodash";

interface FormErrorMessageProps {
  errors: any;
  name: string;
  className?: string;
}

export function FormErrorMessage({
  errors,
  name,
  className = "text-red-500 ml-3",
}: FormErrorMessageProps) {
  const error = get(errors, name);
  if (!error?.message) return null;
  return <span className={className}>{error.message}</span>;
}
